"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Store;
    }
});
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Store = class Store {
    static async get(key, lookInCache = false, ncMeta = _Noco.default.ncMeta) {
        // get from cache if lookInCache is true
        if (lookInCache) {
            const storeData = key && await _NocoCache.default.get('root', `${_globals.CacheScope.STORE}:${key}`, _globals.CacheGetType.TYPE_OBJECT);
            if (storeData) return storeData;
        }
        const storeData = await ncMeta.metaGet(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, {
            key
        });
        if (lookInCache) await _NocoCache.default.set('root', `${_globals.CacheScope.STORE}:${key}`, storeData);
        return storeData;
    }
    static async saveOrUpdate(store, ncMeta = _Noco.default.ncMeta) {
        if (!store.key) {
            _catchError.NcError.badRequest('Key is required');
        }
        const insertObj = (0, _extractProps.extractProps)(store, [
            'key',
            'value',
            'type',
            'env',
            'tag'
        ]);
        const existing = await Store.get(store.key, false, ncMeta);
        if (existing) {
            await ncMeta.metaUpdate(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, insertObj, {
                key: store.key
            });
        } else {
            await ncMeta.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.STORE, insertObj, true);
        }
        if (store.key) await _NocoCache.default.del('root', `${_globals.CacheScope.STORE}:${store.key}`);
    }
    constructor(data){
        Object.assign(this, data);
    }
};
